import { useState } from "react";
import MobileCameraSelect from "./components/MobileCameraSelect";
import DesktopCameraSelect from "./components/DesktopCameraSelect";

type Props = {
  children?: any;
  isOpen?: boolean;
  cameraList: MappedCameraInfo[] | null;
  activeCameraId: string | null;
  forceDarkMode?: boolean;
  close?: Cb;
  changeCamera: Cb<string, Promise<boolean | void>>;
  isDisabled?: boolean;
};

export default function CameraList({
  isOpen,
  isDisabled,
  children,
  cameraList,
  activeCameraId,
  forceDarkMode,
  changeCamera,
  close
}: Props) {
  const [loadingCameraId, setLoadingCameraId] = useState<null | string>(null);

  const hasBackCamera = cameraList?.find((c) => c?.facing === "BACK");
  const hasFrontCamera = cameraList?.find((c) => c.facing === "FRONT");

  const CameraSelectComponent = hasBackCamera || hasFrontCamera ? MobileCameraSelect : DesktopCameraSelect;

  async function handleCameraChange(cameraId: string) {
    if (loadingCameraId) {
      log.warn("already changing");
      return;
    }
    if (activeCameraId === cameraId) return;
    setLoadingCameraId(cameraId);
    await changeCamera(cameraId);
    setLoadingCameraId(null);
  }
  if (!cameraList || cameraList.length < 2) return null;

  // use OptionsMenu component
  // log.warn("Use 'OptionsMenu' component instead");

  return (
    <CameraSelectComponent
      isOpen={isDisabled ? false : isOpen}
      close={close}
      cameraId={activeCameraId}
      cameraList={cameraList}
      changeCamera={handleCameraChange}
      loadingCameraId={loadingCameraId}
      forceDarkMode={forceDarkMode}
    >
      {children}
    </CameraSelectComponent>
  );
}
